import React from 'react';
import MembershipsDatatable from '../../../Memberships/components/MembershipsDatatable';
import { useMembershipProductShowContext } from '../../startup/MembershipProductShowApp';
import '../../../../shared/styles/settingsCardStyles.css';

export default function MembersSection() {
  const { membershipProduct, datatablePath, stats } = useMembershipProductShowContext();
  if (!datatablePath) return null;

  const memberCount = stats && stats.active_member_count;
  const membershipProductId = membershipProduct && membershipProduct.id;

  return (
    <div className="team-member-card mb-3">
      <div className="team-member-card-header">
        <div className="team-member-card-header-left">
          <div className="team-member-card-title-row">
            <h2 className="team-member-card-title">Members</h2>
            {typeof memberCount === 'number' && (
              <span className="team-member-count-badge">{memberCount} active</span>
            )}
          </div>
        </div>
      </div>
      <div className="team-member-card-body">
        <MembershipsDatatable
          datatablePath={datatablePath}
          membershipProductId={membershipProductId}
          showProductColumn={false}
        />
      </div>
    </div>
  );
}
